export enum SHARE_TYPE {
    EMAIL = 1
}